import { render } from "./ContactUs.vue?vue&type=template&id=265c1d29"
const script = {}

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__